import { Typography } from "@mui/material";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkBorder from "../../components/atoms/TkBorder";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { labelids } from "../../assets/data/TkExplanationProperty";

const stepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const info: ITkFakeTableLineProps = {
  keyword: "info",
  type: "explanatoryText",
  explanatoryText: <div className="info">{labelids.labelid.LBLR411108_08}</div>,
};

const retireeName: ITkFakeTableLineProps = {
  keyword: "retireeName",
  type: "contractorAndNumber",
  contractorName: "退職者名",
  showLine: false,
};

const downloadLink = (
  <div>
    　　・
    <a
      href="https://www.wam.go.jp/hp/wp-content/uploads/ininzyou31.pdf"
      target="_blank"
      rel="noreferrer"
    >
      代表者請求権における委任状をダウンロード
    </a>
    <br />
    　　　・
    <a
      href="https://www.wam.go.jp/hp/wp-content/uploads/kisai31ininzyou.pdf"
      target="_blank"
      rel="noreferrer"
    >
      委任状の記載例
    </a>
  </div>
);

const address: ITkFakeTableLineProps = {
  keyword: "lineTitle",
  type: "lineTitle",
  lineTitle: (
    <TkBorder>
      <Typography>【郵送先】</Typography>
      <Typography>〒105－8486</Typography>
      <Typography>
        東京都港区虎ノ門４－３－１３　ヒューリック神谷町ビル９階
      </Typography>
      <Typography>独立行政法人福祉医療機構　共済部退職給付課　宛</Typography>
    </TkBorder>
  ),
};

const lineTitle: ITkFakeTableLineProps = {
  keyword: "lineTitle",
  type: "lineTitle",
  lineTitle: labelids.labelid.LBLR411108_14,
};

// 続柄：戸籍上の配偶者
const fakeTableList1: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: `${labelids.labelid.LBLR411108_02}\\n${labelids.labelid.LBLR411108_04}`,
    explanatoryTextRule: "\\n",
  },
  info,
  retireeName,
  {
    title: "１. 「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathCertificate",
    type: "fileUpload",
    id: "1",
    requiredIcon: true,
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411108_09,
    explanatoryTextRule: "\\n",
  },
  lineTitle,
  address,
];

// 続柄：内縁の妻又は夫
const fakeTableList2: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: `${labelids.labelid.LBLR411108_02}\\n${labelids.labelid.LBLR411108_05}`,
    explanatoryTextRule: "\\n",
  },
  info,
  retireeName,
  {
    title: "１. 「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathCertificate",
    type: "fileUpload",
    id: "1",
    requiredIcon: true,
  },
  {
    title:
      "４. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "familyRegisterOfSingle",
    type: "fileUpload",
    id: "2",
    requiredIcon: true,
  },
  {
    title: "５. 職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certificateOfResidence",
    type: "fileUpload",
    id: "3",
    requiredIcon: true,
  },
  {
    title: "６. その他、事実上の配偶者であることを証明する書類",
    keyword: "certificateOfCLRelationship",
    type: "fileUpload",
    id: "4",
    requiredIcon: true,
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411108_10,
    explanatoryTextRule: "\\n",
  },
  lineTitle,
  address,
];

// 続柄：その他（生計維持関係あり）
const fakeTableList3: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: `${labelids.labelid.LBLR411108_02}\\n${labelids.labelid.LBLR411108_06}`,
    explanatoryTextRule: "\\n",
  },
  info,
  retireeName,
  {
    title: "１. 「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathCertificate",
    type: "fileUpload",
    id: "1",
    requiredIcon: true,
  },
  {
    title:
      "２. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livingReportOfFamily",
    type: "fileUpload",
    id: "2",
    requiredIcon: true,
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: `${labelids.labelid.LBLR411108_11}\\n${labelids.labelid.LBLR411108_13}`,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: downloadLink,
  },
  lineTitle,
  address,
];

// 続柄：その他（生計維持関係なし）
const fakeTableList4: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: `${labelids.labelid.LBLR411108_02}\\n${labelids.labelid.LBLR411108_07}`,
    explanatoryTextRule: "\\n",
  },
  info,
  retireeName,
  {
    title: "１. 「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathCertificate",
    type: "fileUpload",
    id: "1",
    requiredIcon: true,
  },
  {
    title:
      "２. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "familyRegisterOfSingle",
    type: "fileUpload",
    id: "2",
    requiredIcon: true,
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: `${labelids.labelid.LBLR411108_12}\\n${labelids.labelid.LBLR411108_13}`,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: downloadLink,
  },
  lineTitle,
  address,
];

// 続柄：(相続人)
const fakeHeirTableList: ITkFakeTableLineProps[] = [
  info,
  retireeName,
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411108_16,
    explanatoryTextRule: "\\n",
  },
  lineTitle,
  address,
];

const schema = {
  deathCertificate: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  livingReportOfCLRelationship: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  certificateOfResidence: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  certificateOfCLRelationship: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  livingReportOfFamily: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  familyRegisterOfSingle: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export {
  stepper,
  fakeTableList1,
  fakeTableList2,
  fakeTableList3,
  fakeTableList4,
  fakeHeirTableList,
  schema,
};
